import { Box, HStack, KdsText, VStack } from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import { getSandboxItemQuantity } from "@/helpers/getSandboxItemQuantity";
import { type ConfigurationBlocProps } from "./ConfigurationBloc.types";

export const ConfigurationBloc = ({ sandboxItem }: ConfigurationBlocProps) => {
  const { t } = useTranslate();

  const totalQuantity = getSandboxItemQuantity(sandboxItem.SandboxItemVersion);
  const sandboxItemVersions = sandboxItem.SandboxItemVersion;

  return (
    <Box rounded="br-lg" bgColor="elevation.first" p="sp-md">
      <VStack gap="sp-md">
        <KdsText as="h2" size="title-sm">
          {t("orderItemSummary.configuration.title")}
        </KdsText>

        <VStack gap="sp-xs2">
          {(
            sandboxItem.SandboxItemToConfiguratorOptions?.map(
              (sandboxItemToConfiguratorOption) =>
                sandboxItemToConfiguratorOption.ConfiguratorOption
            ) ?? []
          ).map((option) => (
            <HStack
              key={option.id}
              wrap="wrap"
              gap="sp-xs2"
              align="center"
              justify="space-between"
            >
              <KdsText>{option.Configurator.name}</KdsText>
              <KdsText size="subtitle-sm">{option.name}</KdsText>
            </HStack>
          ))}

          <HStack
            wrap="wrap"
            gap="sp-xs2"
            align="center"
            justify="space-between"
          >
            <KdsText>{t("inputs.quantity.label")}</KdsText>
            <KdsText size="subtitle-sm">{totalQuantity}</KdsText>
          </HStack>

          <HStack
            wrap="wrap"
            gap="sp-xs2"
            align="center"
            justify="space-between"
          >
            <KdsText transform="capitalize">
              {t("version.title", { count: sandboxItemVersions.length })}
            </KdsText>
            <KdsText size="subtitle-sm">{sandboxItemVersions.length}</KdsText>
          </HStack>
        </VStack>

        {sandboxItem.specificRequest && (
          <VStack gap="sp-xs">
            <KdsText size="subtitle-sm">
              {t("orderItemSummary.specificRequest.title")}
            </KdsText>
            <KdsText>{sandboxItem.specificRequest}</KdsText>
          </VStack>
        )}
      </VStack>
    </Box>
  );
};
